import { UNREGISTERED_USER_IDS } from './constants';
import userStorage from './storage';
export const isRegisteredUser = (userDetails) => {
    return userDetails ? !UNREGISTERED_USER_IDS.includes(userDetails.id) : false;
};
export const getCurrentUserID = () => {
    return userStorage.getUserDetails().id;
};
